import { render, staticRenderFns } from "./FormChecklistTemplate.vue?vue&type=template&id=3fb9d185"
import script from "./FormChecklistTemplate.vue?vue&type=script&lang=js"
export * from "./FormChecklistTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormChecklistTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb9d185')) {
      api.createRecord('3fb9d185', component.options)
    } else {
      api.reload('3fb9d185', component.options)
    }
    module.hot.accept("./FormChecklistTemplate.vue?vue&type=template&id=3fb9d185", function () {
      api.rerender('3fb9d185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormChecklistTemplate.vue"
export default component.exports